import React, { Component } from 'react'

export class Blogs extends Component {
  render() {
    return (
      <div>Blogs</div>
    )
  }
}

export default Blogs